var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"mt-btn",attrs:{"disabled":_vm.disabled},on:{"click":function($event){$event.preventDefault();return _vm.click.apply(null, arguments)}}},[_c('span',[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }